import { render, staticRenderFns } from "./RedirectElearningDownload.vue?vue&type=template&id=22a54ef0&"
import script from "./RedirectElearningDownload.vue?vue&type=script&lang=js&"
export * from "./RedirectElearningDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports